import * as React from 'react';
import Project from 'src/entities/Project';
import NumberFormater from 'src/services/number-formater/NumberFormater.service';
import Person from 'src/entities/Person';
import ImageContainer from 'src/modules/commons/images/Image.container';

interface Props {
  project: Project;
  projectInterested: Person[];
}

const ProjectMainInfoCardComponent: React.StatelessComponent<Props> = (props: Props) => {
  const ticketValue = NumberFormater.euros(props.project.ticketValue * 1, 0);

  const premoneyValuation = NumberFormater.euros(props.project.premoneyValuation * 1, 0);

  const cashTarget = NumberFormater.euros(Math.round(props.project.cashTarget), 0);

  const coInvestorsInvest = NumberFormater.euros(props.project.coInvestorsInvest * 1, 0);
  
  const interested = props.projectInterested ? props.projectInterested.length : props.project.interested;

  const equity = props.project.equity.toLocaleString('es-ES', {maximumFractionDigits: 2});

  return (
    <section>
      <div className="projects-card-wallet projects-card-preview">
        <div
          className="simple-card"
          style={{
            height: '100%',
            width: '100%',
            position: 'relative',
            zIndex: 1,
            float: 'none',
            display: 'inline-table',
            padding: '30px 0'
          }}
        >
          <div className="col-md-4">
            <p className="padding-left-30 deco-title">
              <ImageContainer 
                alt={props.project.company.name}
                url={props.project.company.logo}
              />
            </p>
            <div className="gap-20"/>
            <p className="padding-left-30">
              {props.project.company.description}
            </p>
            <div className="gap-30"/>
            <p className="c-grey padding-left-30">
              Valor del ticket: {ticketValue}
            </p>
          </div>

          <div className="col-md-4 border-right-dashed border-left-dashed">
            {props.project.premoneyValuation === 0 ?
              null :
              <div className="icon-content">
                <img
                  alt="Euro"
                  className="icon"
                  src="/img/euro-big.png"
                />
                <p className="inline-block f-s-20">
                  Valoración Pre-money:<br/>
                  <strong>{premoneyValuation}</strong>
                </p>
              </div>
            }
            <div className="gap-20"/>
            <div className="icon-content">
              <img
                alt="Euro"
                className="icon"
                src="/img/hand-big.png"
              />
              <p className="inline-block f-s-20">
                Importe de la ronda:<br/>
                <strong>{cashTarget}</strong>
              </p>
            </div>
            <div className="gap-20"/>
            <div className="icon-content">
              <img
                alt="Euro"
                className="icon"
                src="/img/dollar-big.png"
              />
              <p className="inline-block f-s-20">
                Co-inversores offline:<br/>
                <strong>{coInvestorsInvest}</strong>
              </p>
            </div>
          </div>
          <div className="col-md-4">
            {props.project.premoneyValuation === 0 ?
              null :
              <div className="icon-content">
                <img
                  alt="Euro"
                  className="icon"
                  src="/img/percent-big.png"
                />
                <p className="inline-block f-s-20">
                  Porcentaje de equity:<br/>
                  <strong>
                    {equity} %
                  </strong>
                </p>
              </div>
            }
            <div className="gap-20"/>
            <div className="icon-content">
              <img
                alt="Euro"
                className="icon"
                src="/img/investors-big.png"
              />
              <p className="inline-block f-s-20">
                Inversores:<br/>
                <strong>{props.project.numberInvestors}</strong>
                <span className="f-s-18 c-grey">
                  &nbsp;inversores
                </span>
              </p>
            </div>
            <div className="gap-20"/>
            <div className="icon-content">
              <img
                alt="Euro"
                className="icon"
                src="/img/star-big.png"
              />
              <p className="inline-block f-s-20">
                Interesados:<br/>
                <strong>{interested}</strong>
                <span className="f-s-18 c-grey">
                  &nbsp;interesados
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};

export default ProjectMainInfoCardComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/ProjectMainInfoCard.component.tsx